package com.tedd.db

import kotlin.Long

public data class TotalForItem(
  public val n: Long,
  public val total: Long,
)
